import styled, { css } from "styled-components";

export const MyList = styled.div`
  border-bottom: 3px solid green;

  ${({ isActive }) =>
    isActive &&
    css`
      border-bottom-color: white;
    `}
`;

export const MyIcon = styled.img`
  width: ${({ w }) => w || "2.4rem"};
  border-radius: ${({ br }) => br || 0};
  object-fit: ${({ of }) => of || "contain"};
  margin-top: ${({ mt }) => mt || 0};
  margin-bottom: ${({ mb }) => mb || 0};
  margin-left: ${({ ml }) => ml || 0};
  margin-right: ${({ mr }) => mr || 0};

  ${({ h }) =>
    h &&
    css`
      height: ${h};
    `}
`;
